import React, { useState, useEffect } from 'react';
import Box from "@mui/material/Box/";
import ModelDropdown from "./ModelDropdown";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import FileDirectory from "../FileDirectory.json";
import { useObjectStore } from "../zustand/objects";


import { Button, Menu, Group, ActionIcon, rem, useMantineTheme } from '@mantine/core';

const AddModelButton = ({iconColour}) => {
  const { setIsMenuOpen, isMenuOpen } = useObjectStore()

  const [show, setShow] = useState(false);
  const [showText, setShowText] = useState(false);
  const [divWidth, setDivWidth] = useState(68);
  const [hover, setHover] = useState(false)

  useEffect(() => {
    show ? setDivWidth(149) : setDivWidth(68)
  })

  const ObjectCategories = Object.keys(FileDirectory);

  const ObjectCategoryArray = [...Object.keys(FileDirectory)]
  // const ObjectCategoryArray = [...Object.keys(FileDirectory), "text", "image"]

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true)
  };
  const handleClose = () => {
    setAnchorEl(null);
    setShow(false);
    setShowText(false);
    setIsMenuOpen(false)
  };

  // ADD TEXT TO END OF ARRAY AND THEN IN MODELDROPDOWN, HAVE TERNARY 
  // THAT ADDS AN EXTRA CUSTOM SELECT TO SELECT TEXT IF THE CATEGORY IS TEXT

  return (
    <Menu closeOnItemClick={false} trigger="hover" style={{ overflow: 'visible' }}>
      <Menu.Target>
        <ActionIcon
          variant="transparent"
          color={!hover ? iconColour.normal : iconColour.hover}
          onPointerOver={() => setHover(true)}
          onPointerLeave={() => setHover(false)}
        >
          <AddBoxOutlinedIcon fontSize='small' />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown style={{ overflow: 'visible' }}>
        {ObjectCategoryArray.map((mapped, i) => (
          <Menu.Item key={i} style={{ overflow: 'visible' }}>
            <ModelDropdown category={mapped} />
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}

export default AddModelButton;